import { useEffect, useState } from 'react'
import style from './input.module.scss'
import useDebounce from 'src/utils/Hooks/useDebounce'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  type?: string
  value?: string | number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const Input = ({ type = 'text', value, onChange, label, className, ...props }: Props) => {
  const [inputValue, setInputValue] = useState(value || '')
  const [event, setEvent] = useState<React.ChangeEvent<HTMLInputElement> | null>(null)
  const debouncedValue = useDebounce(event, 200)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)
    setEvent(e)
  }

  useEffect(() => {
    if ((debouncedValue || debouncedValue === '') && onChange) {
      onChange(debouncedValue as React.ChangeEvent<HTMLInputElement>)
    }
  }, [debouncedValue])

  return (
    <label className={style.input + ' ' + className + ' ' + (type === 'radio' ? style.radio : '')}>
      <input
        type={type}
        value={inputValue}
        onChange={(e) => handleChange(e)}
        {...props}
        placeholder="Text"
        title={label}
      />
      {type === 'radio' && <span className={style.radioCheck} />}
      {label && <span className={style.label}>{label}</span>}
    </label>
  )
}

export default Input
